import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.sell');
import { normalizeSubscriber, formatSubscriberInput, readSubscriberInput } from "src/libs/portal/season/contact-policy";
import { CONTACT_EMAIL_PATTERN } from "src/libs/portal/season/contact-policy";
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { PATENT_FIELDS, saleMethodLabel } from "src/libs/portal/season/market-catalog";

type RightType = 'patent' | 'trademark' | 'design';
type ModalStep = 'profile' | 'rights' | 'complete';
type AgreementKey = 'uploadFeeAgreed' | 'commissionAgreed';
type ApprovalAction = 'create' | 'update' | 'delete';
type ApprovalActionLabel = '신규 등록' | '수정' | '판매 종료';
type SaleDocumentType = 'REGISTRATION_PUBLICATION' | 'REFERENCE_DOCUMENT' | 'RIGHT_IMAGE';
type AssistanceRightType = 'PATENT' | 'UTILITY_MODEL' | 'TRADEMARK' | 'DESIGN';
type AssistanceView = 'form' | 'uploading' | 'complete' | 'detail';
type AssistanceUploadStatus = 'pending' | 'uploading' | 'success' | 'failed';

interface AssistanceForm {
    name: string;
    phone: string;
    email: string;
    rightType: AssistanceRightType;
    registrationNumber: string;
    rightName: string;
    preferredContactTime: string;
    message: string;
    noMaterials: boolean;
    privacyAgreed: boolean;
    feeAgreed: boolean;
}

interface AssistanceUploadFile {
    file: any;
    name: string;
    size: number;
    mimeType: string;
    progress: number;
    status: AssistanceUploadStatus;
    error: string;
}

interface SaleFileMetadata {
    filename: string;
    size: number;
    mimeType: string;
    documentType: SaleDocumentType;
    visibility: 'PUBLIC' | 'PRIVATE';
    url?: string;
}

interface PatentApplication {
    title: string;
    registrationNumber: string;
    registrationDate: string;
    applicationNumber: string;
    applicationDate: string;
    technologyFields: string[];
    ownerName: string;
    desiredPrice: string;
    feature: string;
}

interface TrademarkApplication {
    title: string;
    designatedGoods: string;
    registrationNumber: string;
    registrationDate: string;
    applicationNumber: string;
    applicationDate: string;
    productFields: string[];
    ownerName: string;
    desiredPrice: string;
}

interface DesignApplication {
    productName: string;
    registrationNumber: string;
    registrationDate: string;
    applicationNumber: string;
    applicationDate: string;
    productField: string;
    ownerName: string;
    desiredPrice: string;
}

interface SellerApplication {
    companyName: string;
    managerName: string;
    contact: string;
    contactPrefix: string;
    contactNumber: string;
    email: string;
    uploadFeeAgreed: boolean;
    commissionAgreed: boolean;
    privacyAgreed: boolean;
    adminRequest: boolean;
    saleMethod: 'TRANSFER' | 'LICENSE' | 'BOTH';
    negotiable: boolean;
    rightType: RightType;
    patent: PatentApplication;
    trademark: TrademarkApplication;
    design: DesignApplication;
}

interface RegisteredRight {
    saleMethod?: string;
    negotiable?: boolean;
    applicationNumber?: string;
    applicationDate?: string;
    summary?: string;
    designatedGoods?: string;
    productName?: string;
    id: string;
    rightId?: string;
    category: string;
    listedAt: string;
    type: RightType;
    typeLabel: string;
    title: string;
    registrationNumber: string;
    registrationDate: string;
    ownerName: string;
    desiredPrice: string;
    fieldSummary: string;
    referenceMaterial: string;
    referenceFiles: string[];
    files?: SaleFileMetadata[];
    registrationPublicationFileName: string;
    imageUrl: string;
    imagePosition: string;
    imageFileName: string;
    status: string;
    requestStatus?: string;
    requestType?: string;
    reference?: string;
    listingId?: string;
    listingStatus?: string;
    targetSaleId?: string;
    targetListingStatus?: string;
    deletionCompletedAt?: string;
    displayStatusLabel?: string;
    displayStatusDescription?: string;
    deletionCompleted?: boolean;
    statusConflict?: boolean;
    receiptNo?: string;
    sellerName?: string;
    sellerCompany?: string;
    sellerPhone?: string;
    sellerEmail?: string;
}

interface ApprovalRequest {
    id: string;
    action: ApprovalAction;
    actionLabel: ApprovalActionLabel;
    requestedAt: string;
    rightId: string;
    right: RegisteredRight;
    status: '승인 대기';
    receiptNo: string;
}

@Component({
    selector: 'wiz-page-sell',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.sell/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageSellComponent implements OnInit {
    public subscriberDisplay = formatSubscriberInput;
    public subscriberLength(value: string): number { return String(value || '').replace(/[^0-9]/g, '').length; }
    public contactPrefixes: string[] = ['010', '011', '016', '017', '018', '019'];
    public technologyFields: string[] = [...PATENT_FIELDS];
    public productClasses: string[] = [
        '1류 - 화학제품·비료·공업용 접착제',
        '2류 - 페인트·도료·방청제',
        '3류 - 화장품·세제·향료',
        '4류 - 공업용 오일·윤활제·연료',
        '5류 - 의약품·위생제·소독제',
        '6류 - 금속재료·철물·금고',
        '7류 - 기계·공작기계·전동공구',
        '8류 - 수공구·칼붙이·면도기',
        '9류 - 전자기기·소프트웨어·계측기',
        '10류 - 의료기기·치과/수의용 기구',
        '11류 - 조명·가열·냉방·위생설비',
        '12류 - 자동차·운송수단',
        '13류 - 화기·탄약·폭약',
        '14류 - 귀금속·보석·시계',
        '15류 - 악기',
        '16류 - 종이·인쇄물·문구',
        '17류 - 고무·플라스틱 반제품·절연재',
        '18류 - 가방·가죽제품·우산',
        '19류 - 비금속 건축재료',
        '20류 - 가구·거울·액자',
        '21류 - 주방/가정용 용기·식기',
        '22류 - 로프·망·텐트·섬유원료',
        '23류 - 직물용 실',
        '24류 - 직물·침구·커튼',
        '25류 - 의류·신발·모자',
        '26류 - 레이스·단추·장식품',
        '27류 - 카펫·매트·벽지',
        '28류 - 완구·게임·운동용품',
        '29류 - 육류·가공식품·유제품',
        '30류 - 커피·차·빵·과자·조미료',
        '31류 - 신선 농산물·식물·사료',
        '32류 - 맥주·비알코올 음료',
        '33류 - 주류',
        '34류 - 담배·흡연용품',
        '35류 - 광고·사업관리·도소매',
        '36류 - 금융·보험·부동산',
        '37류 - 건설·수리·설치',
        '38류 - 통신',
        '39류 - 운송·보관·여행',
        '40류 - 재료처리·인쇄·재활용',
        '41류 - 교육·훈련·엔터테인먼트',
        '42류 - 과학기술·소프트웨어 개발',
        '43류 - 음식점·숙박',
        '44류 - 의료·미용·농업 서비스',
        '45류 - 법률·보안·개인서비스'
    ];
    public designClasses: string[] = [
        '1류 - 식품',
        '2류 - 의류·잡화',
        '3류 - 여행용품·가방·개인용품',
        '4류 - 브러시류',
        '5류 - 직물·시트 재료',
        '6류 - 가구',
        '7류 - 가정용품·주방용품',
        '8류 - 공구·철물',
        '9류 - 포장·운반용 용기',
        '10류 - 시계·계측/신호 기기',
        '11류 - 장식품',
        '12류 - 운송/승강 수단',
        '13류 - 전기 생산/공급 장비',
        '14류 - 기록·통신·정보기기',
        '15류 - 기계류',
        '16류 - 사진/광학 기기',
        '17류 - 악기',
        '18류 - 인쇄/사무기계',
        '19류 - 문구·사무용품·교재',
        '20류 - 판매/광고 장비·표지',
        '21류 - 게임·완구·스포츠용품',
        '22류 - 무기·화약·사냥/낚시용품',
        '23류 - 유체공급·위생·난방/환기',
        '24류 - 의료/실험실 장비',
        '25류 - 건축 단위/건설부재',
        '26류 - 조명기구',
        '27류 - 담배/흡연용품',
        '28류 - 화장/의약/세면용품',
        '29류 - 소방·재난방지/구조 장비',
        '30류 - 동물 관리용품',
        '31류 - 식음료 조리기계/기구'
    ];

    public application: SellerApplication = this.createApplication();
    public selectedFiles: Record<string, string[]> = this.createSelectedFiles();
    public selectedFileMetadata: Record<string, SaleFileMetadata[]> = this.createSelectedFileMetadata();
    public registrationPublicationFileName: string = '';
    public selectedDocumentPreviews: Record<string, string> = {};
    public editDocumentPreviews: Record<string, string> = {};
    public productClassToAdd: string = '';
    public modalStep: ModalStep = 'profile';
    public showRegistrationModal: boolean = false;
    public draftRights: RegisteredRight[] = [];
    public rightImageSheetUrl: string = '/assets/sell/right-thumbs-sheet.png';
    public submittedRights: RegisteredRight[] = [];
    public saleRequestsLoading: boolean = false;
    public saleRequestsError: string = '';
    public loginRequired: boolean = false;
    public saleRequestDetailLoading: boolean = false;
    public submittedAt: string = '';
    public selectedRight: RegisteredRight | null = null;
    public copiedIdentifier: string = '';
    private copyIdentifierResetTimer: any = null;
    public showEditModal: boolean = false;
    public editingRight: RegisteredRight | null = null;
    public editDraft: RegisteredRight | null = null;
    public pendingRequests: ApprovalRequest[] = [];
    public showDeleteModal: boolean = false;
    public deletingRight: RegisteredRight | null = null;
    public showConsultModal: boolean = false;
    public consultingRight: RegisteredRight | null = null;
    public consultMessage: string = '';
    public consultSubmitted: boolean = false;
    public saleSubmitting: boolean = false;
    public adminRequestCompleted: boolean = false;
    public adminRequestReceiptNo: string = '';
    public showSellerConfirmationModal: boolean = false;
    public pendingSaleAction: ApprovalAction | null = null;
    public pendingSaleRight: RegisteredRight | null = null;
    public showRegistrationEntryModal: boolean = false;
    public showAssistanceModal: boolean = false;
    public assistanceView: AssistanceView = 'form';
    public assistanceSubmitting: boolean = false;
    public assistanceProfile: any = { name: '', phone: '', email: '' };
    public assistanceForm: AssistanceForm = this.createAssistanceForm();
    public assistanceFiles: AssistanceUploadFile[] = [];
    public assistanceResult: any = null;
    public assistanceRightTypes: Array<{ value: AssistanceRightType; label: string }> = [
        { value: 'PATENT', label: '특허' },
        { value: 'UTILITY_MODEL', label: '실용신안' },
        { value: 'TRADEMARK', label: '상표' },
        { value: 'DESIGN', label: '디자인' }
    ];
    public readonly assistanceMaxFileCount: number = 10;
    public readonly assistanceMaxFileBytes: number = 20 * 1024 * 1024;
    public readonly assistanceMaxTotalBytes: number = 100 * 1024 * 1024;

    constructor(@Inject( Service) public service: Service) { }

    public methodLabel(method?: string) { return saleMethodLabel({ saleMethod: method || this.application.saleMethod }); }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/market/cases')) return;
        await this.loadSaleRequests();
        await this.loadAssistanceProfile();
        await this.service.render();
    }

    @HostListener('document:keydown.escape')
    public async onEscapeKey() {
        if (this.showAssistanceModal && !this.assistanceSubmitting) {
            await this.closeAssistanceModal();
            return;
        }
        if (this.showRegistrationEntryModal) await this.closeRegistrationEntryModal();
    }

    public async loadSaleRequests(showLoading: boolean = true) {
        if (showLoading) {
            this.saleRequestsLoading = true;
            this.saleRequestsError = '';
            await this.service.render();
        }

        const { code, data } = await wiz.call('get_sale_requests', {});
        this.saleRequestsLoading = false;
        if (code === 401) {
            this.loginRequired = true;
            this.submittedRights = [];
            this.saleRequestsError = '';
            await this.service.render();
            return;
        }
        this.loginRequired = false;
        if (code !== 200) {
            this.submittedRights = [];
            this.saleRequestsError = data?.message || '판매 요청 목록을 불러오지 못했습니다.';
            await this.service.render();
            return;
        }

        const items = Array.isArray(data?.items) ? data.items : [];
        this.submittedRights = items.map((item: any) => this.mapSaleRequest(item));
        this.saleRequestsError = '';
        await this.service.render();
    }

    public async openRegistrationModal(resetForm: boolean = false) {
        if (this.loginRequired) {
            location.href = '/access';
            return;
        }
        if (resetForm) {
            this.application = this.createApplication();
            this.selectedFiles = this.createSelectedFiles();
            this.selectedFileMetadata = this.createSelectedFileMetadata();
            this.resetDocumentSelection();
            this.productClassToAdd = '';
            this.draftRights = [];
            this.adminRequestCompleted = false;
            this.adminRequestReceiptNo = '';
            this.modalStep = 'profile';
        }
        this.showRegistrationEntryModal = true;
        this.showRegistrationModal = false;
        await this.service.render();
    }

    public async closeRegistrationEntryModal() {
        this.showRegistrationEntryModal = false;
        await this.service.render();
    }

    public async startDirectRegistration() {
        this.showRegistrationEntryModal = false;
        this.showRegistrationModal = true;
        await this.service.render();
    }

    public async startAssistanceRegistration() {
        this.showRegistrationEntryModal = false;
        this.assistanceForm = this.createAssistanceForm();
        this.assistanceFiles = [];
        this.assistanceResult = null;
        this.assistanceView = 'form';
        this.showAssistanceModal = true;
        await this.service.render();
    }

    public async closeAssistanceModal() {
        if (this.assistanceSubmitting) return;
        this.showAssistanceModal = false;
        await this.service.render();
    }

    public async loadAssistanceProfile() {
        let response: any;
        try {
            response = await wiz.call('get_assistance_profile', {});
        } catch (_error) {
            return;
        }
        const { code, data } = response || {};
        if (code !== 200 || !data?.profile) return;
        this.assistanceProfile = {
            name: String(data.profile.name || '').trim(),
            phone: String(data.profile.phone || '').trim(),
            email: String(data.profile.email || '').trim()
        };
    }

    public async onAssistanceFilesSelect(event: any) {
        const picked = Array.prototype.slice.call(event.target.files || []);
        event.target.value = '';
        if (!picked.length) return;

        const next = [...this.assistanceFiles];
        const rejected: string[] = [];
        for (const file of picked) {
            if (next.length >= this.assistanceMaxFileCount) {
                rejected.push(`${file.name}: 최대 10개 초과`);
                continue;
            }
            if (!this.isAllowedAssistanceFile(file)) {
                rejected.push(`${file.name}: 지원하지 않는 형식`);
                continue;
            }
            if (Number(file.size || 0) > this.assistanceMaxFileBytes) {
                rejected.push(`${file.name}: 20MB 초과`);
                continue;
            }
            const nextTotal = next.reduce((sum, item) => sum + item.size, 0) + Number(file.size || 0);
            if (nextTotal > this.assistanceMaxTotalBytes) {
                rejected.push(`${file.name}: 전체 100MB 초과`);
                continue;
            }
            next.push({
                file,
                name: String(file.name || ''),
                size: Number(file.size || 0),
                mimeType: String(file.type || 'application/octet-stream'),
                progress: 0,
                status: 'pending',
                error: ''
            });
        }

        this.assistanceFiles = next;
        if (next.length) this.assistanceForm.noMaterials = false;
        await this.service.render();
        if (rejected.length) {
            await this.service.modal.error(`일부 파일을 추가하지 못했습니다.\n${rejected.join('\n')}`);
        }
    }

    public async removeAssistanceFile(index: number) {
        if (this.assistanceSubmitting) return;
        this.assistanceFiles = this.assistanceFiles.filter((_file, fileIndex) => fileIndex !== index);
        await this.service.render();
    }

    public async onAssistanceNoMaterialsChange() {
        if (this.assistanceForm.noMaterials) this.assistanceFiles = [];
        await this.service.render();
    }

    public assistanceTotalFileSize() {
        return this.assistanceFiles.reduce((sum, item) => sum + item.size, 0);
    }

    public formatFileSize(size: number) {
        const bytes = Math.max(0, Number(size || 0));
        if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
        if (bytes >= 1024) return `${(bytes / 1024).toFixed(1)}KB`;
        return `${bytes}B`;
    }

    public assistanceSuccessfulFiles() {
        return this.assistanceFiles.filter((item) => item.status === 'success');
    }

    public assistanceFailedFiles() {
        return this.assistanceFiles.filter((item) => item.status === 'failed');
    }

    public assistanceStatusLabel(status: string = '') {
        const normalized = String(status || '').trim().toUpperCase();
        if (normalized === 'SUBMITTED') return '접수 완료';
        if (normalized === 'IN_REVIEW') return '자료 확인 중';
        if (normalized === 'COMPLETED') return '처리 완료';
        return '처리 상태 확인 중';
    }

    public async submitAssistanceRequest() {
        if (this.assistanceSubmitting || !(await this.validateAssistanceForm())) return;
        if (!this.assistanceFiles.length) this.assistanceForm.noMaterials = true;

        this.assistanceSubmitting = true;
        await this.service.render();
        let response: any;
        try {
            response = await wiz.call('create_assistance_request', {
                payload: JSON.stringify({
                    requester: {
                        name: this.assistanceForm.name.trim(),
                        phone: this.assistanceForm.phone.trim(),
                        email: this.assistanceForm.email.trim()
                    },
                    rightType: this.assistanceForm.rightType,
                    registrationNumber: this.assistanceForm.registrationNumber.trim(),
                    rightName: this.assistanceForm.rightName.trim(),
                    preferredContactTime: this.assistanceForm.preferredContactTime.trim(),
                    message: this.assistanceForm.message.trim(),
                    noMaterials: this.assistanceForm.noMaterials,
                    privacyAgreed: this.assistanceForm.privacyAgreed,
                    feeAgreed: this.assistanceForm.feeAgreed
                })
            });
        } catch (_error) {
            this.assistanceSubmitting = false;
            await this.service.modal.error('대행 요청 접수 중 연결이 끊겼습니다. 잠시 후 다시 시도해주세요.');
            await this.service.render();
            return;
        }
        const { code, data } = response || {};

        if (code !== 200 || !data?.item) {
            this.assistanceSubmitting = false;
            await this.service.modal.error(this.assistanceRequestError(data));
            await this.service.render();
            return;
        }
        const result = data.item;
        if (String(result.status || '').trim().toUpperCase() !== 'SUBMITTED') {
            this.assistanceSubmitting = false;
            await this.service.modal.error('접수 상태를 확인하지 못했습니다. 파일은 업로드하지 않았습니다.');
            await this.service.render();
            return;
        }

        this.assistanceResult = result;
        this.assistanceView = 'uploading';
        await this.service.render();
        for (let index = 0; index < this.assistanceFiles.length; index += 1) {
            await this.uploadAssistanceFile(index);
        }
        this.assistanceSubmitting = false;
        this.assistanceView = 'complete';
        await this.service.render();
    }

    public async retryAssistanceFile(index: number) {
        if (this.assistanceSubmitting || !this.assistanceResult) return;
        this.assistanceSubmitting = true;
        await this.uploadAssistanceFile(index);
        this.assistanceSubmitting = false;
        await this.service.render();
    }

    public async retryFailedAssistanceFiles() {
        if (this.assistanceSubmitting || !this.assistanceResult) return;
        this.assistanceSubmitting = true;
        const failedIndexes = this.assistanceFiles
            .map((item, index) => item.status === 'failed' ? index : -1)
            .filter((index) => index >= 0);
        for (const index of failedIndexes) await this.uploadAssistanceFile(index);
        this.assistanceSubmitting = false;
        await this.service.render();
    }

    public async openAssistanceDetail() {
        if (!this.assistanceResult?.id) return;
        this.assistanceView = 'detail';
        await this.service.render();
    }

    public async backToAssistanceComplete() {
        this.assistanceView = 'complete';
        await this.service.render();
    }

    private async uploadAssistanceFile(index: number) {
        const item = this.assistanceFiles[index];
        if (!item || !this.assistanceResult?.id || item.status === 'success') return;
        item.status = 'uploading';
        item.progress = 0;
        item.error = '';
        await this.service.render();
        const formData = new FormData();
        formData.append('file', item.file);
        try {
            const response: any = await this.service.file.upload(
                `${wiz.url('upload_assistance_file')}?id=${encodeURIComponent(this.assistanceResult.id)}`,
                formData,
                async (percent: number) => {
                    item.progress = Math.max(0, Math.min(100, Math.round(Number(percent || 0))));
                    await this.service.render();
                }
            );
            if (response && response.code === 200) {
                item.status = 'success';
                item.progress = 100;
            } else {
                item.status = 'failed';
                item.error = response?.data?.message || '파일 업로드에 실패했습니다.';
            }
        } catch (_error) {
            item.status = 'failed';
            item.error = '파일 업로드 중 연결이 끊겼습니다.';
        }
        await this.service.render();
    }

    private async validateAssistanceForm() {
        const form = this.assistanceForm;
        if (!form.name.trim()) {
            await this.service.modal.error('이름을 입력해주세요.');
            return false;
        }
        if (!form.phone.trim() && !form.email.trim()) {
            await this.service.modal.error('연락처 또는 이메일을 하나 이상 입력해주세요.');
            return false;
        }
        if (form.phone.trim() && String(form.phone).replace(/\D/g, '').length < 9) {
            await this.service.modal.error('연락처 형식을 확인해주세요.');
            return false;
        }
        if (form.email.trim() && !this.isValidEmail(form.email)) {
            await this.service.modal.error('이메일 형식을 확인해주세요.');
            return false;
        }
        if (!form.registrationNumber.trim() && !form.rightName.trim()) {
            await this.service.modal.error('등록번호 또는 권리명을 하나 이상 입력해주세요.');
            return false;
        }
        if (!form.privacyAgreed || !form.feeAgreed) {
            await this.service.modal.error('개인정보 처리와 수수료 안내에 모두 동의해주세요.');
            return false;
        }
        return true;
    }

    private isAllowedAssistanceFile(file: any) {
        const name = String(file?.name || '').toLowerCase();
        return /\.(pdf|jpe?g|png|gif|webp|bmp|hwp|hwpx|doc|docx|xls|xlsx|zip)$/.test(name);
    }

    public async closeRegistrationModal() {
        this.showRegistrationModal = false;
        await this.service.render();
    }

    public async openRightDetail(right: RegisteredRight) {
        this.selectedRight = right;
        this.copiedIdentifier = '';
        this.saleRequestDetailLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('get_sale_request', { id: right.id });
        if (code === 200 && data?.item) {
            this.selectedRight = this.mapSaleRequest(data.item);
        } else if (code === 401) {
            this.selectedRight = null;
            this.loginRequired = true;
        } else if (code !== 200) {
            await this.service.modal.error(data?.message || '판매 요청 상세를 불러오지 못했습니다.');
        }
        this.saleRequestDetailLoading = false;
        await this.service.render();
    }

    public async closeRightDetail() {
        this.selectedRight = null;
        this.copiedIdentifier = '';
        if (this.copyIdentifierResetTimer) {
            clearTimeout(this.copyIdentifierResetTimer);
            this.copyIdentifierResetTimer = null;
        }
        await this.service.render();
    }

    public async openEditModal(right: RegisteredRight, event?: any) {
        if (event) event.stopPropagation();

        if (!this.canEditSaleRequest(right)) {
            await this.service.modal.error('판매 종료 요청 또는 종료 완료 상태에서는 수정 요청을 할 수 없습니다.');
            return;
        }

        const pendingRequest = this.pendingRequestForRight(right.id);
        if (pendingRequest?.action === 'delete') {
            await this.service.modal.error('판매 종료 요청 중인 권리는 수정 요청을 할 수 없습니다.');
            return;
        }

        const sourceRight = pendingRequest?.action === 'update' ? pendingRequest.right : right;
        this.editingRight = right;
        this.editDraft = {
            ...sourceRight,
            referenceFiles: [...sourceRight.referenceFiles],
            files: [...(sourceRight.files || this.legacyFileMetadata(sourceRight))]
        };
        this.editDocumentPreviews = {};
        this.selectedRight = null;
        this.showEditModal = true;
        await this.service.render();
    }

    public async closeEditModal() {
        this.showEditModal = false;
        this.editingRight = null;
        this.editDraft = null;
        this.editDocumentPreviews = {};
        await this.service.render();
    }

    public async openDeleteModal(right: RegisteredRight, event?: any) {
        if (event) event.stopPropagation();

        if (!this.canRequestSaleTermination(right)) {
            await this.service.modal.error('이미 판매 종료가 요청되었거나 완료된 권리입니다.');
            return;
        }

        this.deletingRight = right;
        this.selectedRight = null;
        this.showDeleteModal = true;
        await this.service.render();
    }

    public async closeDeleteModal() {
        if (this.saleSubmitting) return;
        this.showDeleteModal = false;
        this.deletingRight = null;
        await this.service.render();
    }

    public async submitDeleteRequest() {
        if (!this.deletingRight || this.saleSubmitting) return;

        this.saleSubmitting = true;
        await this.service.render();
        const summaryRight = this.deletingRight;
        let sourceRight = summaryRight;
        try {
            const { code, data } = await wiz.call('get_sale_request', { id: summaryRight.id });
            if (code === 200 && data?.item) {
                const detailRight = this.mapSaleRequest(data.item);
                sourceRight = {
                    ...summaryRight,
                    ...detailRight,
                    rightId: detailRight.rightId || summaryRight.rightId,
                    typeLabel: detailRight.typeLabel || summaryRight.typeLabel,
                    title: detailRight.title || summaryRight.title,
                    registrationNumber: detailRight.registrationNumber || summaryRight.registrationNumber,
                    registrationDate: detailRight.registrationDate || summaryRight.registrationDate,
                    ownerName: detailRight.ownerName || summaryRight.ownerName,
                    desiredPrice: detailRight.desiredPrice || summaryRight.desiredPrice,
                    fieldSummary: detailRight.fieldSummary || summaryRight.fieldSummary,
                    referenceFiles: detailRight.referenceFiles.length ? detailRight.referenceFiles : summaryRight.referenceFiles,
                    files: detailRight.files?.length ? detailRight.files : summaryRight.files,
                    sellerName: detailRight.sellerName || summaryRight.sellerName,
                    sellerCompany: detailRight.sellerCompany || summaryRight.sellerCompany,
                    sellerPhone: detailRight.sellerPhone || summaryRight.sellerPhone,
                    sellerEmail: detailRight.sellerEmail || summaryRight.sellerEmail
                };
            }
        } catch (_error) {
            sourceRight = summaryRight;
        }
        const right: RegisteredRight = {
            ...sourceRight,
            referenceFiles: [...sourceRight.referenceFiles],
            files: [...(sourceRight.files || this.legacyFileMetadata(sourceRight))]
        };
        const result = await this.createCoreSaleRequest('delete', right);
        this.saleSubmitting = false;
        if (!result) {
            await this.service.render();
            return;
        }

        this.showDeleteModal = false;
        this.deletingRight = null;
        await this.loadSaleRequests(false);
        await this.service.modal.success(`판매 종료 요청이 접수되었습니다. 접수번호: ${result.receiptNo}`);
        await this.service.render();
    }

    public async saveEdit() {
        if (!this.editDraft || !this.editingRight || this.saleSubmitting) return;

        if (!this.editDraft.title || !this.editDraft.registrationNumber || !this.editDraft.registrationDate || !this.editDraft.ownerName || !this.editDraft.fieldSummary || !this.editDraft.desiredPrice) {
            await this.service.modal.error('수정할 권리 정보를 입력해주세요.');
            return;
        }
        if (!this.isFixedPrice(this.editDraft.desiredPrice)) {
            await this.service.modal.error('특정 지정가는 범위가 아닌 하나의 금액으로 입력해주세요.');
            return;
        }

        const draft: RegisteredRight = {
            ...this.editDraft,
            id: this.editingRight.id,
            category: this.editingRight.category,
            status: this.editingRight.status,
            referenceFiles: [...this.editDraft.referenceFiles],
            files: [...(this.editDraft.files || this.legacyFileMetadata(this.editDraft))]
        };
        await this.openSellerConfirmation('update', draft);
    }

    public async closeSellerConfirmation() {
        if (this.saleSubmitting) return;
        this.showSellerConfirmationModal = false;
        this.pendingSaleAction = null;
        this.pendingSaleRight = null;
        await this.service.render();
    }

    public saleConfirmationTitle() {
        if (this.pendingSaleAction === 'update') return '수정 요청 판매자 확인';
        return '판매 종료 요청 판매자 확인';
    }

    public async confirmPendingSaleRequest() {
        if (!this.pendingSaleAction || !this.pendingSaleRight || this.saleSubmitting) return;
        if (!(await this.validateProfile())) return;

        this.saleSubmitting = true;
        await this.service.render();
        const action = this.pendingSaleAction;
        const right = this.pendingSaleRight;
        const result = await this.createCoreSaleRequest(action, right);
        this.saleSubmitting = false;
        if (!result) {
            await this.service.render();
            return;
        }

        this.showSellerConfirmationModal = false;
        this.pendingSaleAction = null;
        this.pendingSaleRight = null;
        if (action === 'update') {
            this.showEditModal = false;
            this.editingRight = null;
            this.editDraft = null;
        } else {
            this.showDeleteModal = false;
            this.deletingRight = null;
        }
        this.clearSellerPersonalData();
        await this.loadSaleRequests(false);
        await this.service.modal.success(`판매 ${action === 'update' ? '수정' : '종료'} 요청이 접수되었습니다. 접수번호: ${result.receiptNo}`);
        await this.service.render();
    }

    public async openConsultModal(right: RegisteredRight, event?: any) {
        if (event) event.stopPropagation();

        this.consultingRight = right;
        this.consultMessage = '';
        this.consultSubmitted = false;
        this.selectedRight = null;
        this.showConsultModal = true;
        await this.service.render();
    }

    public async closeConsultModal() {
        this.showConsultModal = false;
        this.consultingRight = null;
        this.consultMessage = '';
        this.consultSubmitted = false;
        await this.service.render();
    }

    public async submitConsult() {
        if (!this.consultMessage.trim()) {
            await this.service.modal.error('관리자 상담 내용을 입력해주세요.');
            return;
        }

        this.consultSubmitted = true;
        await this.service.render();
    }

    public pendingRequestForRight(rightId: string): ApprovalRequest | null {
        return this.pendingRequests.find((request) => request.rightId === rightId) || null;
    }

    public approvalRequestDescription(request: ApprovalRequest) {
        if (request.action === 'create') return '관리자 승인 후 판매 등록 목록에 추가됩니다.';
        if (request.action === 'update') return '관리자 승인 후 요청한 수정 내용으로 교체됩니다.';
        return '관리자가 승인하면 판매 공개가 즉시 종료됩니다.';
    }

    public async updateContactPrefix() {
        this.syncContact();
        await this.service.render();
    }

    public async onContactNumberInput(event: any) {
        const value = readSubscriberInput(event);
        this.application.contactNumber = value;
        event.target.value = value;
        this.syncContact();
        await this.service.render();
    }

    public async finishModal() {
        this.showRegistrationModal = false;
        this.draftRights = [];
        this.application = this.createApplication();
        this.selectedFiles = this.createSelectedFiles();
        this.selectedFileMetadata = this.createSelectedFileMetadata();
        this.resetDocumentSelection();
        this.productClassToAdd = '';
        this.adminRequestCompleted = false;
        this.adminRequestReceiptNo = '';
        this.modalStep = 'profile';
        await this.service.render();
    }

    public stepClass(step: ModalStep) {
        const order: Record<ModalStep, number> = { profile: 1, rights: 2, complete: 3 };
        if (this.modalStep === step) return 'border-cyan-700 bg-cyan-700 text-white';
        if (order[this.modalStep] > order[step]) return 'border-cyan-200 bg-cyan-50 text-cyan-800';
        return 'border-slate-200 bg-white text-slate-500';
    }

    public async goProfileStep() {
        this.modalStep = 'profile';
        await this.service.render();
    }

    public async goRightsStep() {
        if (!(await this.validateProfile())) return;
        this.modalStep = 'rights';
        await this.service.render();
    }

    public async toggleAgreement(key: AgreementKey) {
        this.application[key] = !this.application[key];
        await this.service.render();
    }

    public async submitAdminRequest() {
        if (this.saleSubmitting) return;
        if (!(await this.validateProfile())) return;

        this.application.adminRequest = true;
        this.saleSubmitting = true;
        await this.service.render();
        const result = await this.createAdminCoreSaleRequest();
        this.saleSubmitting = false;
        if (!result) {
            this.application.adminRequest = false;
            await this.service.render();
            return;
        }

        this.draftRights = [];
        this.adminRequestCompleted = true;
        this.adminRequestReceiptNo = result.receiptNo;
        this.clearSellerPersonalData();
        this.submittedAt = this.todayLabel();
        this.modalStep = 'complete';
        await this.loadSaleRequests(false);
        await this.service.render();
    }

    public async selectRightType(type: RightType) {
        this.application.rightType = type;
        this.productClassToAdd = '';
        await this.service.render();
    }

    public isTechnologyFieldSelected(field: string) {
        return this.application.patent.technologyFields.includes(field);
    }

    public async toggleTechnologyField(field: string) {
        const fields = this.application.patent.technologyFields;
        const index = fields.indexOf(field);

        if (index >= 0) {
            fields.splice(index, 1);
            await this.service.render();
            return;
        }

        if (fields.length >= 2) {
            await this.service.modal.error('기술분야는 2개까지 선택할 수 있습니다.');
            return;
        }

        fields.push(field);
        await this.service.render();
    }

    public isProductFieldSelected(field: string) {
        return this.application.trademark.productFields.includes(field);
    }

    public async toggleProductField(field: string) {
        const fields = this.application.trademark.productFields;
        const index = fields.indexOf(field);

        if (index >= 0) {
            fields.splice(index, 1);
        } else {
            fields.push(field);
        }

        await this.service.render();
    }

    public async addProductField() {
        const field = this.productClassToAdd;
        if (!field) {
            await this.service.modal.error('추가할 상품분야를 선택해주세요.');
            return;
        }

        if (!this.application.trademark.productFields.includes(field)) {
            this.application.trademark.productFields.push(field);
        }

        this.productClassToAdd = '';
        await this.service.render();
    }

    public async removeProductField(field: string) {
        this.application.trademark.productFields = this.application.trademark.productFields.filter((item) => item !== field);
        await this.service.render();
    }

    public async selectDesignField(field: string) {
        this.application.design.productField = field;
        await this.service.render();
    }

    public async onFilesSelect(event: any, key: string, limit: number) {
        const files = Array.prototype.slice.call(event.target.files || []);
        const selected = files.slice(0, limit);
        this.selectedFiles[key] = selected.map((file: any) => file.name);
        if (key === 'documents') {
            this.selectedDocumentPreviews = {};
            const previews = await Promise.all(selected.map((file: any) => this.isPublicationImage(file) ? this.readFileAsDataUrl(file) : Promise.resolve('')));
            selected.forEach((file: any, index: number) => {
                this.selectedDocumentPreviews[file.name] = previews[index];
            });
            this.selectedFileMetadata[key] = selected.map((file: any, index: number) => this.fileMetadata(
                file,
                index === 0 ? 'REGISTRATION_PUBLICATION' : 'REFERENCE_DOCUMENT',
                index === 0 ? 'PUBLIC' : 'PRIVATE'
            ));
            this.registrationPublicationFileName = selected[0]?.name || '';
        } else {
            this.selectedFileMetadata[key] = selected.map((file: any) => this.fileMetadata(file, 'RIGHT_IMAGE', 'PUBLIC'));
        }

        if (files.length > limit) {
            await this.service.modal.error(`파일은 최대 ${limit}개까지 업로드할 수 있습니다.`);
        }

        event.target.value = '';
        await this.service.render();
    }

    public selectedDocumentMetadata() {
        return this.selectedFileMetadata.documents || [];
    }

    public documentPreview(fileName: string) {
        return this.selectedDocumentPreviews[fileName] || '';
    }

    public isRegistrationPublication(fileName: string) {
        return this.registrationPublicationFileName === fileName;
    }

    public async setRegistrationPublication(fileName: string) {
        if (!this.selectedFiles.documents.includes(fileName)) return;
        this.registrationPublicationFileName = fileName;
        this.selectedFileMetadata.documents = this.designateRegistrationPublication(
            this.selectedFileMetadata.documents,
            fileName
        );
        await this.service.render();
    }

    public async removeSelectedDocument(fileName: string) {
        this.selectedFiles.documents = this.selectedFiles.documents.filter((name) => name !== fileName);
        this.selectedFileMetadata.documents = this.selectedFileMetadata.documents.filter((file) => file.filename !== fileName);
        delete this.selectedDocumentPreviews[fileName];
        if (this.registrationPublicationFileName === fileName) {
            this.registrationPublicationFileName = this.selectedFiles.documents[0] || '';
        }
        this.selectedFileMetadata.documents = this.designateRegistrationPublication(
            this.selectedFileMetadata.documents,
            this.registrationPublicationFileName
        );
        await this.service.render();
    }

    public async addCurrentRight() {
        if (!(await this.validateRightDetail())) return;

        this.draftRights = [
            ...this.draftRights,
            this.createRegisteredRight()
        ];
        this.resetRightDetail(this.application.rightType);
        this.selectedFiles = this.createSelectedFiles();
        this.selectedFileMetadata = this.createSelectedFileMetadata();
        this.resetDocumentSelection();
        this.productClassToAdd = '';
        await this.service.render();
    }

    public async removeDraftRight(id: string) {
        this.draftRights = this.draftRights.filter((right) => right.id !== id);
        await this.service.render();
    }

    public async submit() {
        if (this.saleSubmitting) return;
        if (!(await this.validateProfile())) return;

        if (!this.draftRights.length) {
            await this.service.modal.error('권리를 1건 이상 완료해주세요.');
            return;
        }

        this.saleSubmitting = true;
        await this.service.render();
        const submitted: RegisteredRight[] = [];
        for (const right of this.draftRights) {
            const result = await this.createCoreSaleRequest('create', right);
            if (!result) break;
            const submittedRight: RegisteredRight = {
                ...right,
                category: '등록 완료',
                status: '등록 완료',
                referenceFiles: [...right.referenceFiles],
                files: [...(right.files || [])],
                receiptNo: result.receiptNo
            };
            submitted.push(submittedRight);
        }
        this.saleSubmitting = false;
        if (submitted.length !== this.draftRights.length) {
            const submittedIds = submitted.map((right) => right.id);
            this.draftRights = this.draftRights.filter((right) => !submittedIds.includes(right.id));
            await this.loadSaleRequests(false);
            await this.service.render();
            return;
        }
        this.draftRights = submitted;
        this.clearSellerPersonalData();
        this.submittedAt = this.todayLabel();
        this.modalStep = 'complete';
        await this.loadSaleRequests(false);
        await this.service.render();
    }

    public rightTypeLabel(type: RightType = this.application.rightType) {
        if (type === 'patent') return '특허/실용';
        if (type === 'trademark') return '상표';
        return '디자인';
    }

    public formatDesiredPrice(price: any) {
        const value = String(price ?? '').trim();
        if (!value) return '특정 지정가 미입력';
        if (value === '0') return '협의';
        if (/^\d+$/.test(value)) return `${Number(value).toLocaleString('ko-KR')}원`;
        return value;
    }

    public requestStatusLabel(status: string = '') {
        const normalized = String(status || '').trim().toUpperCase();
        const labels: Record<string, string> = {
            SUBMITTED: '접수됨',
            IN_REVIEW: '처리 중',
            NEEDS_REVISION: '추가 정보 필요',
            APPROVED: '반영 예정',
            PUBLISHED: '판매 목록 반영됨',
            REJECTED: '처리 불가',
            CANCELLED: '취소됨'
        };
        return labels[normalized] || '처리 상태 확인 중';
    }

    public requestStatusBadgeClass(status: string = '') {
        const normalized = String(status || '').trim().toUpperCase();
        if (normalized === 'NEEDS_REVISION') return 'bg-amber-50 text-amber-700';
        if (normalized === 'REJECTED') return 'bg-rose-50 text-rose-700';
        if (normalized === 'CANCELLED') return 'bg-slate-100 text-slate-700';
        if (normalized === 'APPROVED' || normalized === 'PUBLISHED') return 'bg-emerald-50 text-emerald-700';
        if (normalized === 'IN_REVIEW') return 'bg-blue-50 text-blue-700';
        return 'bg-cyan-50 text-cyan-700';
    }

    public deleteRequestStatus(right: RegisteredRight | null) {
        if (!right || String(right.requestType || '').toUpperCase() !== 'DELETE') return null;

        const status = String(right.requestStatus || right.status || '').trim().toUpperCase();
        const targetListingStatus = String(right.targetListingStatus || '').trim().toUpperCase();
        const listingStatus = String(right.listingStatus || '').trim().toUpperCase();
        const hasEnded = targetListingStatus === 'ENDED' || (!targetListingStatus && listingStatus === 'ENDED');
        const hasPublished = targetListingStatus === 'PUBLISHED' || listingStatus === 'PUBLISHED';
        const hasCompletion = !!String(right.deletionCompletedAt || '').trim();
        const conflict = {
            label: '상태 확인 필요',
            description: '판매 종료 처리 상태를 다시 확인해주세요.',
            completed: false,
            conflict: true
        };

        if (['SUBMITTED', 'IN_REVIEW', 'NEEDS_REVISION'].includes(status)) {
            if (hasEnded || hasCompletion) return conflict;
            return {
                label: '판매 종료 요청',
                description: '관리자가 판매 종료 요청을 확인하고 있습니다.',
                completed: false,
                conflict: false
            };
        }
        if (status === 'APPROVED') {
            if (hasPublished || (targetListingStatus && targetListingStatus !== 'ENDED')) {
                return conflict;
            }
            return {
                label: '판매 종료 완료',
                description: '관리자 승인으로 판매 공개가 종료되었습니다.',
                completed: true,
                conflict: false
            };
        }
        if (status === 'REJECTED' || status === 'CANCELLED') {
            if (hasEnded || hasCompletion) return conflict;
            return {
                label: status === 'REJECTED' ? '판매 종료 요청 반려' : '판매 종료 요청 취소',
                description: '',
                completed: false,
                conflict: false
            };
        }
        return conflict;
    }

    public saleRequestStatusLabel(right: RegisteredRight | null) {
        const deleteStatus = this.deleteRequestStatus(right);
        return deleteStatus?.label || this.requestStatusLabel(right?.requestStatus || right?.status || '');
    }

    public saleRequestStatusDescription(right: RegisteredRight | null) {
        return this.deleteRequestStatus(right)?.description || '';
    }

    public saleRequestStatusBadgeClass(right: RegisteredRight | null) {
        const deleteStatus = this.deleteRequestStatus(right);
        if (deleteStatus?.conflict) return 'bg-amber-50 text-amber-700';
        if (deleteStatus?.completed) return 'bg-emerald-50 text-emerald-700';
        return this.requestStatusBadgeClass(right?.requestStatus || right?.status || '');
    }

    public canEditSaleRequest(right: RegisteredRight | null) {
        if (!right) return false;
        if (this.deleteRequestStatus(right) || String(right.listingStatus || '').toUpperCase() === 'ENDED') return false;
        return true;
    }

    public canRequestSaleTermination(right: RegisteredRight | null) {
        return this.canEditSaleRequest(right);
    }

    public formatUserDateTime(value: string = '') {
        const raw = String(value || '').trim();
        if (!raw) return '';
        const date = new Date(raw);
        if (Number.isNaN(date.getTime())) return raw;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    }

    public requestTypeLabel(requestType: string = '') {
        const normalized = String(requestType || '').trim().toUpperCase();
        const labels: Record<string, string> = {
            CREATE: '신규 등록',
            UPDATE: '정보 수정',
            DELETE: '판매 종료'
        };
        return labels[normalized] || '요청 내용 확인 중';
    }

    public requestTypeBadgeClass(requestType: string = '') {
        const normalized = String(requestType || '').trim().toUpperCase();
        if (normalized === 'DELETE') return 'bg-rose-50 text-rose-700';
        if (normalized === 'UPDATE') return 'bg-amber-50 text-amber-700';
        if (normalized === 'CREATE') return 'bg-emerald-50 text-emerald-700';
        return 'bg-slate-100 text-slate-700';
    }

    public listingStatusLabel(status: string = '') {
        const normalized = String(status || '').trim().toUpperCase();
        if (normalized === 'PUBLISHED') return '공개 중';
        if (normalized === 'ENDED') return '판매 종료';
        return normalized ? '상태 확인 중' : '상태 미확인';
    }

    public shortIdentifier(value: string = '', visibleLength: number = 14) {
        const identifier = String(value || '').trim();
        if (identifier.length <= visibleLength) return identifier || '-';
        return `${identifier.slice(0, visibleLength)}…`;
    }

    public async copyIdentifier(value: string = '') {
        const identifier = String(value || '').trim();
        if (!identifier) return;

        let copied = false;
        try {
            const clipboard = (navigator as any).clipboard;
            if (clipboard && typeof clipboard.writeText === 'function') {
                await clipboard.writeText(identifier);
                copied = true;
            } else {
                copied = this.copyTextFallback(identifier);
            }
        } catch (error) {
            copied = this.copyTextFallback(identifier);
        }

        if (!copied) {
            await this.service.modal.error('ID를 복사하지 못했습니다.');
            return;
        }

        this.copiedIdentifier = identifier;
        await this.service.render();

        if (this.copyIdentifierResetTimer) clearTimeout(this.copyIdentifierResetTimer);
        this.copyIdentifierResetTimer = setTimeout(async () => {
            if (this.copiedIdentifier !== identifier) return;
            this.copiedIdentifier = '';
            this.copyIdentifierResetTimer = null;
            await this.service.render();
        }, 2000);
    }

    private copyTextFallback(value: string) {
        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        let copied = false;
        try {
            copied = document.execCommand('copy');
        } catch (error) {
            copied = false;
        }

        document.body.removeChild(textarea);
        return copied;
    }

    public thumbnailStyle(right: RegisteredRight | null) {
        if (!right) return {};
        const isSheetImage = right.imageUrl === this.rightImageSheetUrl;
        return {
            'background-image': `url("${right.imageUrl}")`,
            'background-position': right.imagePosition || 'center',
            'background-size': isSheetImage ? '200% 200%' : 'cover',
            'background-repeat': 'no-repeat'
        };
    }

    public async onEditImageSelect(event: any) {
        if (!this.editDraft) return;

        const file = (event.target.files || [])[0];
        if (!file) return;

        const imageUrl = await this.readFileAsDataUrl(file);
        if (!this.editDraft.registrationPublicationFileName) {
            this.editDraft.imageUrl = imageUrl;
            this.editDraft.imagePosition = 'center';
            this.editDraft.imageFileName = file.name;
        }
        this.editDraft.files = [
            ...(this.editDraft.files || this.legacyFileMetadata(this.editDraft)).filter((item) => item.documentType !== 'RIGHT_IMAGE'),
            this.fileMetadata(file, 'RIGHT_IMAGE', 'PUBLIC')
        ];
        event.target.value = '';
        await this.service.render();
    }

    public async onEditReferenceFilesSelect(event: any) {
        if (!this.editDraft) return;

        const files = Array.prototype.slice.call(event.target.files || []);
        if (files.length > 3) {
            await this.service.modal.error('등록공보 및 증빙자료는 최대 3개까지 선택할 수 있습니다.');
        }

        const selected = files.slice(0, 3);
        const previews = await Promise.all(selected.map((file: any) => this.isPublicationImage(file) ? this.readFileAsDataUrl(file) : Promise.resolve('')));
        this.editDocumentPreviews = {};
        selected.forEach((file: any, index: number) => {
            this.editDocumentPreviews[file.name] = previews[index];
        });
        this.editDraft.referenceFiles = selected.map((file: any) => file.name);
        this.editDraft.files = [
            ...selected.map((file: any, index: number) => this.fileMetadata(
                file,
                index === 0 ? 'REGISTRATION_PUBLICATION' : 'REFERENCE_DOCUMENT',
                index === 0 ? 'PUBLIC' : 'PRIVATE'
            )),
            ...(this.editDraft.files || this.legacyFileMetadata(this.editDraft)).filter((item) => item.documentType === 'RIGHT_IMAGE')
        ];
        this.editDraft.registrationPublicationFileName = selected[0]?.name || '';
        if (selected[0] && previews[0]) {
            this.editDraft.imageUrl = previews[0];
            this.editDraft.imagePosition = 'center';
            this.editDraft.imageFileName = selected[0].name;
        }
        this.editDraft.referenceMaterial = this.editDraft.referenceFiles.length ? this.editDraft.referenceFiles.join(', ') : '참고자료 미첨부';
        event.target.value = '';
        await this.service.render();
    }

    public isEditRegistrationPublication(fileName: string) {
        if (!this.editDraft) return false;
        return this.editDraft.registrationPublicationFileName === fileName;
    }

    public async setEditRegistrationPublication(fileName: string) {
        if (!this.editDraft || !this.editDraft.referenceFiles.includes(fileName)) return;
        this.editDraft.files = this.designateRegistrationPublication(
            this.editDraft.files || this.legacyFileMetadata(this.editDraft),
            fileName
        );
        this.editDraft.registrationPublicationFileName = fileName;
        const publication = this.editDraft.files.find((file) => file.filename === fileName);
        this.editDraft.imageUrl = this.editDocumentPreviews[fileName] || (this.isPublicationImage(publication) ? publication?.url : '') || this.editDraft.imageUrl;
        this.editDraft.imagePosition = 'center';
        this.editDraft.imageFileName = fileName;
        await this.service.render();
    }

    public async removeEditReferenceFile(fileName: string) {
        if (!this.editDraft) return;

        this.editDraft.referenceFiles = this.editDraft.referenceFiles.filter((file) => file !== fileName);
        this.editDraft.files = (this.editDraft.files || []).filter((file) => file.filename !== fileName);
        delete this.editDocumentPreviews[fileName];
        if (this.editDraft.registrationPublicationFileName === fileName) {
            const nextPublication = this.editDraft.referenceFiles[0] || '';
            this.editDraft.registrationPublicationFileName = nextPublication;
            this.editDraft.files = this.designateRegistrationPublication(this.editDraft.files, nextPublication);
            if (nextPublication) {
                const publication = this.editDraft.files.find((file) => file.filename === nextPublication);
                this.editDraft.imageUrl = this.editDocumentPreviews[nextPublication] || (this.isPublicationImage(publication) ? publication?.url : '') || this.editDraft.imageUrl;
                this.editDraft.imagePosition = 'center';
                this.editDraft.imageFileName = nextPublication;
            }
        }
        this.editDraft.referenceMaterial = this.editDraft.referenceFiles.length ? this.editDraft.referenceFiles.join(', ') : '참고자료 미첨부';
        await this.service.render();
    }

    private async openSellerConfirmation(action: ApprovalAction, right: RegisteredRight) {
        this.pendingSaleAction = action;
        this.pendingSaleRight = right;
        this.showSellerConfirmationModal = true;
        await this.service.render();
    }

    private async createCoreSaleRequest(action: ApprovalAction, right: RegisteredRight): Promise<any | null> {
        const isDelete = action === 'delete';
        const seller = isDelete ? this.deleteSellerPayload(right) : this.sellerPayload();
        return this.submitCoreSaleRequest(action, {
            targetSaleId: isDelete ? right.id : '',
            seller,
            right: {
                id: right.rightId || right.id,
                rightType: right.typeLabel || this.rightTypeLabel(right.type) || '권리',
                rightTitle: right.title || (isDelete ? '삭제 대상 권리' : ''),
                registrationNumber: right.registrationNumber || (isDelete ? right.id : ''),
                registrationDate: right.registrationDate || (isDelete ? this.todayLabel() : ''),
                ownerName: right.ownerName || (isDelete ? seller.company || seller.name || '삭제 대상 권리자' : ''),
                field: right.fieldSummary || (isDelete ? right.category || '삭제 요청' : ''),
                category: right.category
            },
            desiredPrice: right.desiredPrice || (isDelete ? '0' : ''),
            saleMethod: right.saleMethod || this.application.saleMethod,
            negotiable: right.negotiable !== false,
            summary: right.summary || '',
            applicationNumber: right.applicationNumber || '',
            applicationDate: right.applicationDate || '',
            designatedGoods: right.designatedGoods || '',
            productName: right.productName || '',
            adminServiceRequested: this.application.adminRequest,
            privacyAgreed: isDelete || this.application.privacyAgreed,
            feeAgreed: isDelete || (this.application.uploadFeeAgreed && this.application.commissionAgreed),
            uploadFeeAgreed: isDelete || this.application.uploadFeeAgreed,
            commissionAgreed: isDelete || this.application.commissionAgreed,
            files: right.files || this.legacyFileMetadata(right)
        });
    }

    private async createAdminCoreSaleRequest(): Promise<any | null> {
        return this.submitCoreSaleRequest('create', {
            seller: this.sellerPayload(),
            right: {
                rightType: this.rightTypeLabel(this.application.rightType),
                rightTitle: '관리자 판매 등록 의뢰',
                registrationNumber: '관리자 확인 예정',
                registrationDate: this.todayLabel(),
                ownerName: this.application.companyName.trim() || this.application.managerName.trim(),
                field: '관리자 확인 예정',
                category: '관리자 의뢰'
            },
            desiredPrice: '0',
            saleMethod: this.application.saleMethod,
            adminServiceRequested: true,
            adminRequestOnly: true,
            privacyAgreed: this.application.privacyAgreed,
            feeAgreed: this.application.uploadFeeAgreed && this.application.commissionAgreed,
            uploadFeeAgreed: this.application.uploadFeeAgreed,
            commissionAgreed: this.application.commissionAgreed,
            files: []
        });
    }

    private async submitCoreSaleRequest(action: ApprovalAction, requestData: any): Promise<any | null> {
        const { code, data } = await wiz.call('submit_sale_request', {
            payload: JSON.stringify({
                requestType: action,
                data: requestData
            })
        });
        if (code !== 200) {
            await this.service.modal.error(this.saleRequestError(data));
            return null;
        }
        return data;
    }

    private sellerPayload() {
        return {
            name: this.application.managerName.trim(),
            company: this.application.companyName.trim(),
            phone: this.application.contact.trim(),
            email: this.application.email.trim()
        };
    }

    private deleteSellerPayload(right: RegisteredRight) {
        return {
            name: right.sellerName || this.assistanceProfile.name || right.ownerName,
            company: right.sellerCompany || right.ownerName,
            phone: right.sellerPhone || this.assistanceProfile.phone,
            email: right.sellerEmail || this.assistanceProfile.email
        };
    }

    private upsertApprovalRequest(action: ApprovalAction, right: RegisteredRight, receiptNo: string) {
        const labels: Record<ApprovalAction, ApprovalActionLabel> = {
            create: '신규 등록',
            update: '수정',
            delete: '판매 종료'
        };
        const existing = this.pendingRequestForRight(right.id);
        const request: ApprovalRequest = {
            id: existing?.id || this.createApprovalRequestId(),
            action,
            actionLabel: labels[action],
            requestedAt: this.todayLabel(),
            rightId: right.id,
            right,
            status: '승인 대기',
            receiptNo
        };

        this.pendingRequests = [
            ...this.pendingRequests.filter((item) => item.rightId !== right.id),
            request
        ];
    }

    private createApprovalRequestId() {
        return `REQUEST-${Date.now()}-${this.pendingRequests.length + 1}`;
    }

    private saleRequestError(data: any) {
        const message = data?.message || '판매 요청 접수에 실패했습니다.';
        if (data?.errorType === 'validation') return `입력값 오류: ${message}`;
        if (data?.errorType === 'network') return `네트워크 오류: ${message}`;
        return `서버 오류: ${message}`;
    }

    private assistanceRequestError(data: any) {
        const message = data?.message || '판매등록 대행 요청 접수에 실패했습니다.';
        const system = data?.origin === 'coreapi' ? 'Core API' : 'IP 거래';
        const code = data?.upstreamCode ? ` (${data.upstreamCode})` : '';
        if (data?.errorType === 'validation') return `입력값 오류: ${message}`;
        if (data?.errorType === 'auth') return `${system} 인증 오류${code}: ${message}`;
        if (data?.errorType === 'network') return `${system} 연결 오류${code}: ${message}`;
        return `${system} 오류${code}: ${message}`;
    }

    private async validateProfile() {
        if (!this.application.companyName || !this.application.managerName || !this.application.contactNumber || !this.application.email) {
            await this.service.modal.error('회사/성명, 담당자, 연락처, 이메일을 입력해주세요.');
            return false;
        }

        if (normalizeSubscriber(this.application.contactNumber) === null) {
            await this.service.modal.error('연락처는 앞자리를 선택하고 나머지 숫자 8자리를 입력해주세요.');
            return false;
        }

        if (!this.isValidEmail(this.application.email)) {
            await this.service.modal.error('이메일 형식으로 입력해주세요.');
            return false;
        }

        if (!this.application.uploadFeeAgreed || !this.application.commissionAgreed || !this.application.privacyAgreed) {
            await this.service.modal.error('필수 동의 항목을 확인해주세요.');
            return false;
        }

        this.syncContact();
        return true;
    }

    private isFixedPrice(value: string) {
        const normalized = String(value || '').trim();
        if (!normalized) return false;
        return !(/[~∼～]|(?:이상|이하|초과|미만|부터|까지|협의)|\d\s*-\s*\d/.test(normalized));
    }

    private async validateRightDetail() {
        if (this.application.rightType === 'patent') {
            const patent = this.application.patent;
            if (!patent.title || !patent.registrationNumber || !patent.registrationDate || !patent.ownerName || !patent.desiredPrice) {
                await this.service.modal.error('특허/실용 등록 정보를 입력해주세요.');
                return false;
            }
            if (!this.isFixedPrice(patent.desiredPrice)) {
                await this.service.modal.error('특정 지정가는 범위가 아닌 하나의 금액으로 입력해주세요.');
                return false;
            }
            if (!patent.technologyFields.length) {
                await this.service.modal.error('기술분야를 1개 이상 선택해주세요.');
                return false;
            }
            return true;
        }

        if (this.application.rightType === 'trademark') {
            const trademark = this.application.trademark;
            if (!trademark.registrationNumber || !trademark.registrationDate || !trademark.ownerName || !trademark.desiredPrice) {
                await this.service.modal.error('상표 등록 정보를 입력해주세요.');
                return false;
            }
            if (!this.isFixedPrice(trademark.desiredPrice)) {
                await this.service.modal.error('특정 지정가는 범위가 아닌 하나의 금액으로 입력해주세요.');
                return false;
            }
            if (!trademark.productFields.length) {
                await this.service.modal.error('상품분야를 1개 이상 선택해주세요.');
                return false;
            }
            return true;
        }

        const design = this.application.design;
        if (!design.registrationNumber || !design.registrationDate || !design.productField || !design.ownerName || !design.desiredPrice) {
            await this.service.modal.error('디자인 등록 정보를 입력해주세요.');
            return false;
        }
        if (!this.isFixedPrice(design.desiredPrice)) {
            await this.service.modal.error('특정 지정가는 범위가 아닌 하나의 금액으로 입력해주세요.');
            return false;
        }

        return true;
    }

    private createRegisteredRight(): RegisteredRight {
        const type = this.application.rightType;
        if (type === 'patent') {
            const patent = this.application.patent;
            const image = this.mainImageForType(type);
            const referenceFiles = this.referenceFileList();
            return {
                id: this.createRightId(),
                category: '등록 완료',
                listedAt: this.todayLabel(),
                type,
                typeLabel: this.rightTypeLabel(type),
                title: patent.title,
                registrationNumber: patent.registrationNumber,
                registrationDate: patent.registrationDate,
                applicationNumber: patent.applicationNumber,
                applicationDate: patent.applicationDate,
                saleMethod: this.application.saleMethod,
                negotiable: this.application.negotiable,
                ownerName: patent.ownerName,
                desiredPrice: patent.desiredPrice,
                fieldSummary: patent.technologyFields.join(', '),
                summary: patent.feature,
                referenceMaterial: this.referenceMaterialSummary(),
                referenceFiles,
                files: this.currentFileMetadata(),
                registrationPublicationFileName: this.registrationPublicationFileName,
                ...image,
                status: '작성 완료'
            };
        }

        if (type === 'trademark') {
            const trademark = this.application.trademark;
            const image = this.mainImageForType(type, this.selectedFiles.trademarkImage[0]);
            const referenceFiles = this.referenceFileList();
            return {
                id: this.createRightId(),
                category: '등록 완료',
                listedAt: this.todayLabel(),
                type,
                typeLabel: this.rightTypeLabel(type),
                title: trademark.title.trim() || '상표 ' + trademark.registrationNumber,
                registrationNumber: trademark.registrationNumber,
                registrationDate: trademark.registrationDate,
                applicationNumber: trademark.applicationNumber,
                applicationDate: trademark.applicationDate,
                saleMethod: this.application.saleMethod,
                negotiable: this.application.negotiable,
                ownerName: trademark.ownerName,
                desiredPrice: trademark.desiredPrice,
                fieldSummary: trademark.productFields.join(', '),
                designatedGoods: trademark.designatedGoods,
                referenceMaterial: this.referenceMaterialSummary(),
                referenceFiles,
                files: this.currentFileMetadata(),
                registrationPublicationFileName: this.registrationPublicationFileName,
                ...image,
                status: '작성 완료'
            };
        }

        const design = this.application.design;
        const image = this.mainImageForType(type, this.selectedFiles.designImage[0]);
        const referenceFiles = this.referenceFileList();
        return {
            id: this.createRightId(),
            category: '등록 완료',
            listedAt: this.todayLabel(),
            type,
            typeLabel: this.rightTypeLabel(type),
            title: design.productName.trim() || '디자인 ' + design.registrationNumber,
            registrationNumber: design.registrationNumber,
            registrationDate: design.registrationDate,
            applicationNumber: design.applicationNumber,
            applicationDate: design.applicationDate,
            saleMethod: this.application.saleMethod,
            negotiable: this.application.negotiable,
            productName: design.productName,
            ownerName: design.ownerName,
            desiredPrice: design.desiredPrice,
            fieldSummary: design.productField,
            referenceMaterial: this.referenceMaterialSummary(),
            referenceFiles,
            files: this.currentFileMetadata(),
            registrationPublicationFileName: this.registrationPublicationFileName,
            ...image,
            status: '작성 완료'
        };
    }

    private mapSaleRequest(item: any): RegisteredRight {
        const right = item?.right && typeof item.right === 'object' ? item.right : {};
        const publicInfo = item?.public_listing || item?.metadata?.public_listing || {};
        const seller = item?.seller && typeof item.seller === 'object' ? item.seller : {};
        const requestStatus = String(item?.status || '').trim().toUpperCase();
        const requestType = String(item?.request_type || item?.requestType || '').trim().toUpperCase();
        const rightTypeLabel = String(right.right_type || item?.right_type || '권리').trim();
        const type = this.coreRightType(rightTypeLabel);
        const rawFiles = Array.isArray(item?.files) ? item.files : [];
        const files: SaleFileMetadata[] = rawFiles.map((file: any) => {
            const documentType = this.saleDocumentType(file?.document_type || file?.documentType);
            return {
                filename: String(file?.filename || file?.name || '').trim(),
                size: Number(file?.size || 0),
                mimeType: String(file?.mime_type || file?.mimeType || file?.type || 'application/octet-stream'),
                documentType,
                visibility: String(file?.visibility || '').toUpperCase() === 'PUBLIC' ? 'PUBLIC' : 'PRIVATE',
                url: String(file?.url || file?.file_url || file?.fileUrl || '').trim()
            };
        }).filter((file: SaleFileMetadata) => !!file.filename).sort((a, b) => this.filePriority(a) - this.filePriority(b));
        const publicationFile = rawFiles.find((file: any) => {
            return String(file?.document_type || file?.documentType || '').toUpperCase() === 'REGISTRATION_PUBLICATION';
        });
        const imageFile = (this.isPublicationImage(publicationFile) ? publicationFile : null) || rawFiles.find((file: any) => this.isPublicationImage(file));
        const referenceFiles = files
            .filter((file) => file.documentType !== 'RIGHT_IMAGE')
            .map((file) => file.filename);
        const defaultImage = this.defaultImageForType(type, String(imageFile?.filename || imageFile?.name || ''));
        const createdAt = String(item?.created_at || item?.createdAt || '').trim();
        const reference = String(item?.reference || item?.receiptNo || '').trim();
        const id = String(item?.id || reference).trim();

        return {
            id,
            saleMethod: String(item?.sale_method || 'TRANSFER'),
            negotiable: publicInfo.negotiable !== false,
            applicationNumber: String(publicInfo.application_number || ''),
            applicationDate: String(publicInfo.application_date || ''),
            summary: String(publicInfo.summary || ''),
            designatedGoods: String(publicInfo.designated_goods || ''),
            productName: String(publicInfo.product_name || ''),
            rightId: String(right.id || item?.right_id || '').trim(),
            category: this.requestStatusLabel(requestStatus),
            listedAt: createdAt ? createdAt.slice(0, 10) : '-',
            type,
            typeLabel: rightTypeLabel,
            title: String(right.right_title || item?.right_title || '권리명 미입력').trim(),
            registrationNumber: String(right.registration_number || item?.registration_number || '').trim(),
            registrationDate: String(right.registration_date || item?.registration_date || '').trim(),
            ownerName: String(right.owner_name || item?.owner_name || '').trim(),
            desiredPrice: String(item?.desired_price ?? item?.desiredPrice ?? ''),
            fieldSummary: String(right.field || item?.field || '').trim(),
            referenceMaterial: referenceFiles.length ? referenceFiles.join(', ') : '참고자료 미첨부',
            referenceFiles,
            files,
            registrationPublicationFileName: String(publicationFile?.filename || publicationFile?.name || '').trim(),
            imageUrl: String(imageFile?.url || imageFile?.file_url || imageFile?.fileUrl || defaultImage.imageUrl),
            imagePosition: imageFile?.url || imageFile?.file_url || imageFile?.fileUrl ? 'center' : defaultImage.imagePosition,
            imageFileName: String(imageFile?.filename || imageFile?.name || defaultImage.imageFileName),
            status: requestStatus,
            requestStatus,
            requestType,
            reference,
            receiptNo: reference || id,
            listingId: String(item?.listing_id || item?.listingId || '').trim(),
            listingStatus: String(item?.listing_status || item?.listingStatus || '').trim().toUpperCase(),
            targetSaleId: String(item?.target_sale_id || item?.targetSaleId || '').trim(),
            targetListingStatus: String(item?.target_listing_status || item?.targetListingStatus || '').trim().toUpperCase(),
            deletionCompletedAt: String(item?.deletion_completed_at || item?.deletionCompletedAt || '').trim(),
            displayStatusLabel: String(item?.display_status_label || item?.displayStatusLabel || '').trim(),
            displayStatusDescription: String(item?.display_status_description || item?.displayStatusDescription || '').trim(),
            deletionCompleted: item?.deletion_completed === true || item?.deletionCompleted === true,
            statusConflict: item?.status_conflict === true || item?.statusConflict === true,
            sellerName: String(seller.name || seller.contact_name || seller.contactName || '').trim(),
            sellerCompany: String(seller.office_name || seller.officeName || seller.company || '').trim(),
            sellerPhone: String(seller.phone || seller.mobile || seller.contact || '').trim(),
            sellerEmail: String(seller.email || seller.contact_email || seller.contactEmail || '').trim()
        };
    }

    private coreRightType(value: string): RightType {
        const normalized = String(value || '').toLowerCase();
        if (normalized.indexOf('상표') >= 0 || normalized.indexOf('trademark') >= 0) return 'trademark';
        if (normalized.indexOf('디자인') >= 0 || normalized.indexOf('design') >= 0) return 'design';
        return 'patent';
    }

    private defaultImageForType(type: RightType, fileName: string = '') {
        const positions: Record<RightType, string> = {
            patent: '0% 0%',
            trademark: '100% 0%',
            design: '0% 100%'
        };

        return {
            imageUrl: this.rightImageSheetUrl,
            imagePosition: positions[type],
            imageFileName: fileName || `${this.rightTypeLabel(type)} 썸네일`
        };
    }

    private mainImageForType(type: RightType, fallbackFileName: string = '') {
        const publicationFileName = this.registrationPublicationFileName;
        const publicationPreview = this.selectedDocumentPreviews[publicationFileName];
        if (publicationFileName && publicationPreview) {
            return {
                imageUrl: publicationPreview,
                imagePosition: 'center',
                imageFileName: publicationFileName
            };
        }
        return this.defaultImageForType(type, fallbackFileName);
    }

    private referenceFileList() {
        return this.currentFileMetadata()
            .filter((file) => file.documentType !== 'RIGHT_IMAGE')
            .map((file) => file.filename);
    }

    public isPdfDocument(fileName: string) {
        return /\.pdf$/i.test(fileName || '');
    }

    private isPublicationImage(file: any) {
        if (!file) return false;
        const type = String(file.mimeType || file.mime_type || file.type || '').toLowerCase();
        const name = String(file.filename || file.name || '');
        return type.startsWith('image/') || ((!type || type === 'application/octet-stream') && /\.(png|jpe?g|gif|webp|avif|bmp)$/i.test(name));
    }

    private readFileAsDataUrl(file: any): Promise<string> {
        return new Promise((resolve) => {
            if (typeof FileReader === 'undefined') {
                resolve(this.editDraft?.imageUrl || this.rightImageSheetUrl);
                return;
            }

            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || this.rightImageSheetUrl));
            reader.onerror = () => resolve(this.editDraft?.imageUrl || this.rightImageSheetUrl);
            reader.readAsDataURL(file);
        });
    }

    private referenceMaterialSummary() {
        const files = this.referenceFileList();

        return files.length ? files.join(', ') : '참고자료 미첨부';
    }

    private resetRightDetail(type: RightType) {
        if (type === 'patent') this.application.patent = this.createPatentApplication();
        if (type === 'trademark') {
            this.application.trademark = this.createTrademarkApplication();
            this.productClassToAdd = '';
        }
        if (type === 'design') this.application.design = this.createDesignApplication();
    }

    private createApplication(): SellerApplication {
        return {
            companyName: '',
            managerName: '',
            contact: '',
            contactPrefix: '010',
            contactNumber: '',
            email: '',
            uploadFeeAgreed: false,
            commissionAgreed: false,
            privacyAgreed: false,
            adminRequest: false,
            saleMethod: 'TRANSFER',
            negotiable: true,
            rightType: 'patent',
            patent: this.createPatentApplication(),
            trademark: this.createTrademarkApplication(),
            design: this.createDesignApplication()
        };
    }

    private createAssistanceForm(): AssistanceForm {
        return {
            name: String(this.assistanceProfile?.name || '').trim(),
            phone: String(this.assistanceProfile?.phone || '').trim(),
            email: String(this.assistanceProfile?.email || '').trim(),
            rightType: 'PATENT',
            registrationNumber: '',
            rightName: '',
            preferredContactTime: '',
            message: '',
            noMaterials: false,
            privacyAgreed: false,
            feeAgreed: false
        };
    }

    private createPatentApplication(): PatentApplication {
        return {
            title: '',
            registrationNumber: '',
            registrationDate: '',
            applicationNumber: '',
            applicationDate: '',
            technologyFields: [],
            ownerName: '',
            desiredPrice: '',
            feature: ''
        };
    }

    private createTrademarkApplication(): TrademarkApplication {
        return {
            title: '',
            designatedGoods: '',
            registrationNumber: '',
            registrationDate: '',
            applicationNumber: '',
            applicationDate: '',
            productFields: [],
            ownerName: '',
            desiredPrice: ''
        };
    }

    private createDesignApplication(): DesignApplication {
        return {
            productName: '',
            registrationNumber: '',
            registrationDate: '',
            applicationNumber: '',
            applicationDate: '',
            productField: '',
            ownerName: '',
            desiredPrice: ''
        };
    }

    private createSelectedFiles(): Record<string, string[]> {
        return {
            documents: [],
            trademarkImage: [],
            designImage: []
        };
    }

    private createSelectedFileMetadata(): Record<string, SaleFileMetadata[]> {
        return {
            documents: [],
            trademarkImage: [],
            designImage: []
        };
    }

    private currentFileMetadata(): SaleFileMetadata[] {
        return [
            ...this.selectedFileMetadata.documents,
            ...this.selectedFileMetadata.trademarkImage,
            ...this.selectedFileMetadata.designImage
        ].sort((a, b) => this.filePriority(a) - this.filePriority(b));
    }

    private fileMetadata(file: any, documentType: SaleDocumentType, visibility: 'PUBLIC' | 'PRIVATE'): SaleFileMetadata {
        return {
            filename: String(file?.name || '').trim(),
            size: Math.max(0, Number(file?.size || 0)),
            mimeType: String(file?.type || 'application/octet-stream'),
            documentType,
            visibility
        };
    }

    private legacyFileMetadata(right: RegisteredRight): SaleFileMetadata[] {
        const referenceFiles = (right.referenceFiles || []).map((filename) => ({
            filename,
            size: 0,
            mimeType: 'application/octet-stream',
            documentType: filename === right.registrationPublicationFileName ? 'REGISTRATION_PUBLICATION' as const : 'REFERENCE_DOCUMENT' as const,
            visibility: filename === right.registrationPublicationFileName ? 'PUBLIC' as const : 'PRIVATE' as const
        }));
        const image = right.imageFileName ? [{
            filename: right.imageFileName,
            size: 0,
            mimeType: 'image/*',
            documentType: 'RIGHT_IMAGE' as const,
            visibility: 'PUBLIC' as const
        }] : [];
        return [...referenceFiles, ...image].sort((a, b) => this.filePriority(a) - this.filePriority(b));
    }

    private designateRegistrationPublication(files: SaleFileMetadata[], fileName: string) {
        return files.map((file) => {
            if (file.documentType === 'RIGHT_IMAGE') return file;
            const isPublication = !!fileName && file.filename === fileName;
            return {
                ...file,
                documentType: isPublication ? 'REGISTRATION_PUBLICATION' as const : 'REFERENCE_DOCUMENT' as const,
                visibility: isPublication ? 'PUBLIC' as const : 'PRIVATE' as const
            };
        }).sort((a, b) => this.filePriority(a) - this.filePriority(b));
    }

    private saleDocumentType(value: any): SaleDocumentType {
        const normalized = String(value || '').toUpperCase();
        if (normalized === 'REGISTRATION_PUBLICATION') return 'REGISTRATION_PUBLICATION';
        if (normalized === 'RIGHT_IMAGE') return 'RIGHT_IMAGE';
        return 'REFERENCE_DOCUMENT';
    }

    private filePriority(file: SaleFileMetadata) {
        if (file.documentType === 'REGISTRATION_PUBLICATION') return 0;
        return 1;
    }

    private resetDocumentSelection() {
        this.registrationPublicationFileName = '';
        this.selectedDocumentPreviews = {};
    }

    private createRightId() {
        return `RIGHT-${Date.now()}-${this.draftRights.length + 1}`;
    }

    private syncContact() {
        const number = normalizeSubscriber(this.application.contactNumber) || '';
        this.application.contact = number.length === 8 ? `${this.application.contactPrefix}-${number.slice(0, 4)}-${number.slice(4)}` : `${this.application.contactPrefix}-${number}`;
    }

    private clearSellerPersonalData() {
        this.application.companyName = '';
        this.application.managerName = '';
        this.application.contact = '';
        this.application.contactNumber = '';
        this.application.email = '';
        this.application.uploadFeeAgreed = false;
        this.application.commissionAgreed = false;
        this.application.privacyAgreed = false;
    }

    private isValidEmail(email: string) {
        return CONTACT_EMAIL_PATTERN.test((email || '').trim());
    }

    private todayLabel() {
        const now = new Date();
        const year = now.getFullYear();
        const month = `${now.getMonth() + 1}`.padStart(2, '0');
        const date = `${now.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${date}`;
    }
}

export default PageSellComponent;